import { PointsTransactionCategory, PointsTransactionReason } from '@aslanpay/portal-common-lib';

export const PointsTransactionReasonLabels: Record<
  PointsTransactionReason,
  { reason: string; notes: string }
> = {
  EMPLOYEE_TOP_UP: { reason: 'Top up', notes: 'This is your bonus top up.' },
  EMPLOYEE_GIFT: {
    reason: 'Employee gift',
    notes: 'Congratulations! Your team has awarded you a points boost.',
  },
  COMPANY_TOP_UP: {
    reason: 'Company top up',
    notes: 'This is your company top up.',
  },
  GOODWILL: { reason: 'Goodwill', notes: 'Please accept these points as a gesture of goodwill.' },
  PURCHASE: { reason: 'Purchase', notes: 'Please accept these bonus points from Aslan.' },
  REFERRAL: { reason: 'Referral', notes: 'Please accept the following points from a referral.' },
  DIGITAL_VOUCHER: {
    reason: 'Digital Voucher',
    notes: 'Please accept the following points from a digital voucher purchase.',
  },
  FUNDS_TOP_UP: {
    reason: 'Funds top up',
    notes: 'Please accept the following points from a funds top up.',
  },
  FUNDS_TRANSFER: {
    reason: 'Funds transfer',
    notes: 'Please accept the following points from a funds transfer.',
  },
  RECOGNITION: {
    reason: 'Recognition',
    notes: 'Please accept the following points as recognition for your work.',
  },
  OTHER: { reason: 'Other', notes: 'Points for a purchase.' },
};

/**
 * Labels for reasons the ledger records but an admin never picks by hand. Kept out of PointsTransactionReasonLabels,
 * which also feeds the reward reason dropdowns.
 */
const SystemPointsTransactionReasonLabels: Record<string, string> = {
  CAMPAIGN: 'Campaign',
  TOP_UP: 'Top up',
  EMPLOYEE_REWARD: 'Employee reward',
};

/**
 * Returns the display label for a points transaction reason, falling back to the raw value for a reason back office
 * doesn't know yet, so a new ledger reason can never break the page that lists it.
 */
export function getPointsTransactionReasonLabel(reason: string): string {
  return (
    PointsTransactionReasonLabels[reason as PointsTransactionReason]?.reason ??
    SystemPointsTransactionReasonLabels[reason] ??
    reason
  );
}

export const PointsTransactionCategoryValues: Record<
  PointsTransactionCategory,
  { color: string; value: string }
> = {
  REWARD: {
    color: 'active',
    value: 'Reward',
  },
  REDEEM: {
    color: 'leaving',
    value: 'Redeem',
  },
  REVOKE: {
    color: 'left',
    value: 'Revoke',
  },
};
